import React from 'react'
import { Link } from 'react-router-dom'
import SideBar from './SideBar'

function Certification() {
  return (
     <div className='w-full lg:w-[60%] mx-auto min-h-screen py-8 lg:py-10 px-6 lg:px-20 relative overflow-y-auto'>
        <SideBar />
         <p className='w-full text-zinc-300 text-md text-left py-2 mb-4'>
            Working with <b>Amazon Web Services</b> made me feel more interested towards how applications were made to scale millions of users and maintaining a low cost. I decided to pursue some of the certifications on <b>cloud</b> platforms.
         </p>
         <ul className='w-full text-left text-md text-black list-number'>
            <li className='underline py-2 text-green-700 cursor-pointer hover:text-green-800'>
              <Link to="https://www.credly.com/badges/f299bb87-f171-4048-993d-cf7821a56a2d" target="__blank">
                AWS Solutions Architect Associate
              </Link>
            </li>
            <li className='underline py-2 text-green-700 cursor-pointer hover:text-green-800'>
              <Link to="https://www.credly.com/badges/5652fc27-bb72-4436-9f1d-cdf434ca89a4" target='__blank'>
                AWS Certified Cloud Practitioner
              </Link>
            </li>
            <li className='underline py-2 text-green-700 cursor-pointer hover:text-green-800'>
              <Link to="https://www.cloudskillsboost.google/public_profiles/6624642f-7451-48c0-96bc-1a154ed3a3b7" target='__blank'>
                Google Cloud Platform Foundational
              </Link>
            </li>
            <li className='underline py-2 text-green-700 cursor-pointer hover:text-green-800'>
              <Link to="https://learn.mongodb.com/c/dfcjjkTzTlKTHNDDgv7gtg" target="__blank">
                MongoDB SI Associate
              </Link>
            </li>
         </ul>
    </div>
  )
}

export default Certification